import React from 'react';
import { useParams } from 'react-router-dom';
import { UserType } from '../../../pages/AddMember/AddMember';
import {
  EXISTING_USER_IN_ALEF_MESSAGE,
  EXISTING_USER_MESSAGE,
  NEW_USER_MESSAGE,
  ORG_MEMBER_MESSAGE,
} from '../../../utils/constants';
import { getSelectedOrganisation } from '../../../utils/getOrgMembership';
import isInCCLiframe from '../../../utils/isInCCLiframe';
import InfoMessage from '../../InfoMessage';

type Props = {
  userType?: UserType;
};

const CheckEmailMessage = ({ userType }: Props) => {
  const { code } = useParams<{ code: string }>();

  const messageMap = {
    [UserType.NEW]: NEW_USER_MESSAGE,
    [UserType.EXISTING]: EXISTING_USER_MESSAGE,
    [UserType.ORG_MEMBER]: ORG_MEMBER_MESSAGE.replace(
      ':code',
      isInCCLiframe ? getSelectedOrganisation() || '' : code || '',
    ),
    [UserType.ALEF_ONLY]: EXISTING_USER_IN_ALEF_MESSAGE,
  };

  const message = () => {
    if (userType) {
      return messageMap[userType] || '';
    }

    return '';
  };

  return <InfoMessage messageText={message()} />;
};

export default CheckEmailMessage;
